import { TauriBrowserAudioProvider } from '../../io/TauriBrowserAudioProvider';

const audioProvider = new TauriBrowserAudioProvider();

export { audioProvider };
